/**
 * @generated SignedSource<<7633a056d37d2993a651a8ab595eb082>>
 * @relayHash 029150958a5e975d5016f41ace91c7fe
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 029150958a5e975d5016f41ace91c7fe

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ICPS"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contractId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ICPS",
        "variableName": "ICPS"
      },
      {
        "kind": "Variable",
        "name": "contractId",
        "variableName": "contractId"
      }
    ],
    "concreteType": "ReopenContractMutationResponse",
    "kind": "LinkedField",
    "name": "reopenContract",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newContractId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReopenContractMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReopenContractMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "029150958a5e975d5016f41ace91c7fe",
    "metadata": {},
    "name": "ReopenContractMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "8c4ada7bad5f00df7b88e705970c7ee7";

export default node;
